import { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, Switch, withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';

import { loadUserWithAccessRule } from '../services/AccessRuleService';
import * as UsuarioService from '../services/UsuarioService';
import PrivateRoute from './PrivateRoute';

import { setAdministrador, setAdministradores } from '../actions/actionsAdmin';
import { setCliente, setClienteData, setServicosCliente } from '../actions/actionsCliente';
import { setPermissoesUsuario } from '../actions/actionsUsuario';

import 'rsuite/dist/styles/rsuite-default.css';
import IPAProvider from '../store/IPAProvider';
import '../style/app.scss';
import { RoutesConfig } from '../utils/Routes';

class PrimaryLayout extends Component {
  constructor(props) {
    super(props);

    this.state = {
      alertas: [],
      usuario: null,
    };

    this.getUser = this.getUser.bind(this);
  }

  componentDidMount() {
    this.getUser();
  }

  shouldComponentUpdate(nextProps, nextState) {
    return nextProps !== this.props || nextState !== this.state;
  }

  componentDidUpdate() {
    const { history } = this.props;
    const { usuario } = this.state;
    const usuarioLogin = JSON.parse(localStorage.getItem('usuario'))?.email;

    if (usuario?.login !== usuarioLogin && history.location.pathname !== '/login') {
      this.getUser();
    }
  }

  getUser() {
    const requestedEmail = JSON.parse(localStorage.getItem('usuario'))?.email;
    if (requestedEmail) {
      const { setCliente, setAdministrador, setPermissoesUsuario, setServicosCliente, setAdministradores, setClienteData } = this.props;

      loadUserWithAccessRule(
        () => UsuarioService.getClienteCompleto(requestedEmail),
        localStorage.getItem('autenticacao.token'),
      ).then(async data => {
        const currentEmail = JSON.parse(localStorage.getItem('usuario'))?.email;
        if (currentEmail !== requestedEmail) return;
        if (data) {
          this.setState({
            usuario: data,
          });
          setCliente(data.codigoCliente);
          setAdministrador(data.usuarioAdministrador);
          setPermissoesUsuario(data.servicos, data.servicoBi, data.servicoPanel, data.servicoIra);
          setServicosCliente(data.servicosCliente);
          setAdministradores(data.administradores);
          setClienteData(data);
        } else {
          // Marca o fim da carga tambem sem usuario, para o menu de produtos sair da espera.
          setClienteData(null);
        }
      });
    }
  }

  render() {
    const { alertas, usuario } = this.state;
    const { history } = this.props;

    const routesMap = RoutesConfig.map(({ path, component, privateRoute, adminArea, ipaRouteAccess }, key) =>
      privateRoute ? (
        <PrivateRoute
          key={key}
          exact
          path={path}
          component={component}
          adminArea={adminArea}
          ipaRouteAccess={ipaRouteAccess}
          alertas={alertas}
          history={history}
          usuario={usuario}
        />
      ) : (
        <Route exact path={path} component={component} key={key} />
      ),
    );

    return (
      <IPAProvider usuario={usuario}>
        <Switch>
          {routesMap}
          <Redirect exact from="/" to="/login" />
        </Switch>
      </IPAProvider>
    );
  }
}

const mapStateToProps = store => ({
  enterAdmin: store.adminDataReducer.enterAdmin,
  permissoes: store.usuarioDataReducer.permissoes,
  codigoCliente: store.clienteDataReducer.codigoCliente,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setPermissoesUsuario,
      setCliente,
      setAdministrador,
      setServicosCliente,
      setAdministradores,
      setClienteData,
    },
    dispatch,
  );

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PrimaryLayout));
